import { gql } from "@apollo/client";
import { contactFragment } from "./fragment";

export const GET_ADDRESS_BOOK_LIST = gql`
  query GetContactList($businessUnit: Int!, $contactType: String) {
    contacts(businessUnit: $businessUnit, contactType: $contactType) {
      ...contactFragment
    }
  }
  ${contactFragment}
`;

export const GET_ADDRESS_BY_ID = gql`
  query GetContactById($id: Int!, $businessUnitId: Int!) {
    contact(id: $id, businessUnitId: $businessUnitId) {
      ...contactFragment
    }
  }
  ${contactFragment}
`;
